<ng-container *transloco="let convert;">
  @if (showHeading) {
    <h3 class="text-uppercase fw-bold h5">{{convert('sellModule.details.bookValue.bookValues')}}</h3>
  }
  @if (bookValues$ | async; as bookValues) {
    <app-book-value-tabs
      [nadaValues]="bookValues.nada"
      [isCanadianTenantEnabled]="isCanadianTenantEnabled"
      [blackBookValues]="bookValues.blackBook"
      [bookProviderName]="bookProviderName"
      [formattedNadaValues]="formattedNadaValues"
      [manheimValues]="bookValues.manheim"
      [formattedBlackBookValues]="formattedBlackBookValues"
      [formattedManheimValues]="formattedManheimValues"
      [tabFocus]="defaultBookValue"
      [isMMREnabled]="isBookValuationManheimValuationEnabled"
      (tabFocusChange)="onTabFocusChange($event)"
      (openExtendedBook)="openBookValueModal($event)"
      [bookValueTabs]="bookValueTrans"
    ></app-book-value-tabs>
  }

  @if (inventoryItem) {
    <app-book-value-modal
      [auctionItemUuid]="inventoryItem.auctionItemUuid"
      [itemDetail]="inventoryItem.itemDetail"
      [vehicleTitle]="vehicleTitle"
      >
    </app-book-value-modal>
  }
</ng-container>
